import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';

import { Button } from '../design-system/Buttons';
import styleVars from '../design-system/scss-vars';
import { HeadingPara } from '../design-system/Headings';
import { mediaBreakpointUpSM, mediaBreakpointUpLG } from '../constants/style-constants';
import phrasesType from '../proptypes/phrases';

const ArchetypeSelector = ({
  phrases, archetypes, selected, onClick,
}) => (
  <>
    <HeadingPara>{phrases.exploreOtherRolesTitle}</HeadingPara>
    <div className="ss_flex-grid">
      {
        archetypes.map(({ id, name }) => (
          <Button
            onClick={() => onClick(id)}
            key={id}
            round
            active={id === selected}
            css={css`
              width: 180px;
              margin: ${styleVars.ssSpaceXs};
              padding: ${styleVars.ssSpaceSm};
              font-size: ${styleVars.ssFontXs};
              font-family: ${styleVars.ssFontFamDisplay};
              line-height: 1.2;

              ${mediaBreakpointUpSM} {
                width: 200px;
                font-size: ${styleVars.ssFontSm};
              }

              ${mediaBreakpointUpLG} {
                margin: ${styleVars.ssSpaceSm};
                padding: ${styleVars.ssSpaceMd};
              }`
            }
          >
            {name}
          </Button>
        ))
      }
    </div>
  </>
);

ArchetypeSelector.propTypes = {
  archetypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  phrases: phrasesType.isRequired,
  selected: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

ArchetypeSelector.defaultProps = {
  selected: undefined,
};

export default ArchetypeSelector;
